import { toast } from "react-toastify";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export const enableApiUser = async (
  token: string,
  userId: number,
  t: (key: string) => string
): Promise<boolean> => {
  if (!token) {
    throw new Error("Token not found");
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/EnableApiUser/${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to enable API user");
    }

    const data: boolean = await response.json();
    return data;
  } catch (error) {
    toast.error(t("somethingWentWrong"));
    throw error;
  }
};